import {
  ChangeDetectorRef,
  Component, DoCheck,
  EventEmitter,
  Input, IterableDiffers,
  OnChanges,
  OnInit,
  Output, Pipe, PipeTransform, ViewChild
} from '@angular/core';
import {UploadFile} from '../../../upload-file';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {Configuration} from '../../../models/configuration';
import {PreConfiguration} from "../../../models/pre-configuration";

@Pipe({name: 'removeExtension'})
export class RemoveExtensionPipe implements PipeTransform {
  transform(value): any {
    if (!value) {
      return value;
    }
    return value.split('.').slice(0, -1).join('.');
  }
}

@Pipe({name: 'getExtension'})
export class GetExtensionPipe implements PipeTransform {
  transform(value): any {
    if (!value) {
      return value;
    }
    return value.split('.').pop();
  }
}

@Pipe({name: 'padFormatting'})
export class NumberFormatPipe implements PipeTransform {
  transform(value, format): any {
    const places = format.length;
    const zero = places - value.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + value;
  }
}

@Component({
  selector: 'app-upload-table',
  templateUrl: './upload-table.component.html',
  styleUrls: ['./upload-table.component.css']
})
export class UploadTableComponent implements OnInit, OnChanges, DoCheck {
  dataSource: any;
  previews: any = [];
  displayedColumns: string[] = ['position', 'thumbnail', 'assetName', 'path', 'status', 'actions'];
  @Input()
  uploadedFiles;
  @Output()
  uploadedFilesChange = new EventEmitter<UploadFile[]>();
  @Output()
  fileDeleted = new EventEmitter<number>();
  @Input()
  files;
  @Input()
  sortRenameConfig;
  iterableDiffer;
  @ViewChild('table', {static: true}) table: MatTable<UploadFile>;
  @Output()
  updateOrder = new EventEmitter<any>();
  @Input()
  configuration: Configuration;
  @Input()
  preConfiguration: PreConfiguration;

  constructor(private changeDetectorRefs: ChangeDetectorRef,
              private iterableDiffers: IterableDiffers) {
    this.iterableDiffer = iterableDiffers.find([]).create(null);
  }

  ngOnInit() {
    this.refresh();
    if (this.configuration.duplicateStrategy !== 'DO_NOTHING') {
      this.displayedColumns = ['position', 'thumbnail', 'assetName', 'path', 'duplicates', 'status', 'actions'];
    }
  }

  generatePreview(file: File, i) {
    const mimeType = file.type;
    if (mimeType.match(/image\/*/) != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.previews[i] = reader.result;
      };
    }
  }

  deleteFile(i: any) {
    this.fileDeleted.emit(i);
    this.dataSource = new MatTableDataSource<UploadFile>(this.uploadedFiles);

  }

  ngOnChanges(): void {
    this.refresh();
  }

  refresh() {
    this.previews = new Array(this.uploadedFiles.size);
    let i = 0;
    this.uploadedFiles.forEach(uploadedFile => {
      this.generatePreview(uploadedFile.file, i++);
    });
    this.dataSource = new MatTableDataSource<UploadFile>(this.uploadedFiles);
    this.changeDetectorRefs.detectChanges();
  }

  ngDoCheck(): void {
    const changes = this.iterableDiffer.diff(this.uploadedFiles);
    if (changes) {
      this.refresh();
    }
  }

  dropTable(event: CdkDragDrop<UploadFile[]>) {
    this.updateOrder.emit({from: this.uploadedFiles.indexOf(event.item.data), to: event.currentIndex});
  }


}
